import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    RefurbishedPageInterface,
    RefurbishedStorageEnum,
    setIsCoachMarkVisible,
    setSelectedFilters,
} from "../RefurbishedSlice";
import { useGetRefurbishedProductsQuery } from "../../../common/api/refurbished";
import { RefurbishedProductIndexInterface } from "../../../common/interfaces/apiV2/refurbished/RefurbishedProductIndexInterface";
interface RefurbishedPageReturnType {
    refurbishedProducts: RefurbishedProductIndexInterface[];
    isLoading: boolean;
    isFetching: boolean;
    refurbishedState: RefurbishedPageInterface;
    handleCloseCoachMark: () => void;
    handleSetFilters: (filters: Record<string, string[]>) => void;
}

export const useRefurbishedPage = (): RefurbishedPageReturnType => {
    const dispatch = useAppDispatch();
    const refurbishedState = useAppSelector((state) => state.refurbished);

    const {
        data: refurbishedProductsData,
        isLoading: refurbishedProductsLoading,
        isFetching: refurbishedProductsFetching,
    } = useGetRefurbishedProductsQuery({
        items_per_page: 9999,
        filter: {
            category_id:
                refurbishedState.selectedFilters.category_id?.map(Number),
            grade_id: refurbishedState.selectedFilters.grade_id?.map(Number),
        },
    });

    const handleCloseCoachMark = (): void => {
        localStorage.setItem(RefurbishedStorageEnum.COACHMARK_CLOSED, "true");
        dispatch(setIsCoachMarkVisible(false));
    };

    const handleSetFilters = (filters: Record<string, string[]>): void => {
        dispatch(setSelectedFilters(filters));
    };

    return {
        refurbishedProducts: refurbishedProductsData?.data ?? [],
        isLoading: refurbishedProductsLoading,
        isFetching: refurbishedProductsFetching,
        refurbishedState,
        handleCloseCoachMark,
        handleSetFilters,
    };
};
